import React from 'react';
import { Route, useHistory } from 'react-router';
import CreateAccount from '../CreateAccountSocialEcomm/CreateAccount';
import Verify from '../Verify/Verify';
import PersonalInfo from '../PersonalInfo/PersonalInfo';
import { useAppContext } from '../../utils/ContextProviders/AppContext';

function SocialEcommRegistrationRoutes() {
  const { setHistory } = useAppContext();
  setHistory(useHistory());
  return (
    <>
      <Route exact path="/create-account" component={CreateAccount} />
      <Route exact path="/create-account/verify" component={Verify} />
      <Route exact path="/create-account/personal-info" component={PersonalInfo} />
    </>
  );
}

export default SocialEcommRegistrationRoutes;
